<div class="category-selection-container">
    <div class="dialog-title-section">
        <h2 class="dialog-title" id="dialog-title">{{ 'request_v2.category-selection.title' | translate }}</h2>
        <p class="dialog-subtitle">{{ 'request_v2.category-selection.subtitle' | translate }}</p>
    </div>

    <div class="search-container">
        <div class="search-input-wrapper">
            <i class="search-icon icon-search"></i>
            <input type="text" class="search-input" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" placeholder="Search your request subject" aria-label="Search request categories" />
        </div>
    </div>


    <div class="categories-container" #categoriesContainer>
        <div class="no-results" *ngIf="filteredCategories.length === 0 && !loading">
            <h3 class="no-results-title">{{ 'request_v2.category-selection.no-results.title' | translate }}</h3>
            <p class="no-results-description">{{ 'request_v2.category-selection.no-results.description' | translate }}</p>
        </div>

        <!-- Dynamically render categories -->
        <div
            *ngFor="let category of filteredCategories"
            class="category-item"
            [class.selected]="category.selected"
            [class.internal]="category.isInternal"
            (click)="selectCategory(category)"
            role="option"
            [attr.aria-selected]="category.selected"
        >
            <div class="category-icon">
                <!-- Use default icon if specific one isn't provided -->
                <i [class]="category.icon || 'icon-map-marker'"></i>
            </div>
            <div class="category-content">
                <div class="category-header">
                    <h3 class="category-title">{{ category.name }}</h3>
                    <span *ngIf="category.isInternal" class="badge-internal">
                        {{ 'request_v2.category-selection.internal_label' | translate }}
                    </span>
                </div>
                <p class="category-description">{{ category.description }}</p>
            </div>
        </div>

        <div class="skeleton-loader-container" *ngIf="loading" >
            <app-skeleton-loader class="skeleton-loader" height="90px" *ngFor="let i of [1, 2, 3,4]"></app-skeleton-loader>
        </div>

    </div>
</div>
